if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        // BUR-12
        this.variantInfo = this.querySelector('.quantity-popover-container');
        // ./BUR-12 
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }
        // BUR-12
        // if (this.popoverInfo && this.infoButtonDesktop && this.mqlTablet.matches) {
        //   this.popoverInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        // }
        
        if (this.popoverInfo && this.infoButtonDesktop && this.mql.matches) {
          this.popoverInfo.addEventListener('mouseenter', this.closePopover.bind(this));
        }
        // ./BUR-12 
        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
          // BUR-12
          this.infoButtonMobile.addEventListener('focusout', this.closePopover.bind(this));
          // ./BUR-12 
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          // BUR-12
          // this.infoButtonDesktop.addEventListener('mouseenter', this.togglePopover.bind(this));
          // this.infoButtonDesktop.addEventListener('mouseleave', this.closePopover.bind(this));
          this.variantInfo.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.variantInfo.addEventListener('mouseleave', this.closePopover.bind(this));
          // ./BUR-12 
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        // BUR-12
        // if ((this.mql.matches && !isExpanded) || event.type === 'click') {
        //   button.setAttribute('aria-expanded', !isExpanded);

        //   this.popoverInfo.toggleAttribute('hidden');

        //   button.classList.toggle('quantity-popover__info-button--open');

        //   this.infoButtonDesktop.classList.add('quantity-popover__info-button--icon-only--animation');
        // }
        button.setAttribute('aria-expanded', !isExpanded);

        this.popoverInfo.toggleAttribute('hidden');
      // ./BUR-12 
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        // BUR-12
        button.classList.toggle('quantity-popover__info-button--open');
        // ./BUR-12 

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
        }
      }

      closePopover(event) {
        event.preventDefault();
        // BUR-12
        // const isButtonChild = this.infoButtonDesktop.contains(event.relatedTarget);
        // const isPopoverChild = this.popoverInfo.contains(event.relatedTarget);
        const isChild = this.variantInfo.contains(event.relatedTarget);
        // ./BUR-12 
        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        // BUR-12
        // if (!isButtonChild && !isPopoverChild) {
        // ./BUR-12 
        if (!event.relatedTarget || !isChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
           // BUR-12
          // this.infoButtonDesktop.classList.remove('quantity-popover__info-button--icon-only--animation');
           // ./BUR-12
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}
